import React, { FC, useState, useRef } from "react";
const downloadIcon = require("../../../../../public/images/download-events.svg");
const downArrowHead = require("../../../../../public/images/down-arrow-head.svg");

interface DownloadEventsProps {
  handleShowTooltip: (id: string, msg: string) => void;
  handleHideTooltip: (id: string) => void;
}

const DownloadEvents: FC<DownloadEventsProps> = ({
  handleShowTooltip,
  handleHideTooltip
}) => {
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [shouldShowDownloadOptions, setShowDownloadOptions] = useState(false);
  const pollingCountRef = useRef(0);

  const checkReportDownloadStatus = async (token: string) => {
    pollingCountRef.current += 1;
    const eventsReportURL = `/api/v1/events/the_export?token=${token}`;

    const response = await fetch(eventsReportURL);

    if (pollingCountRef.current === 25) {
      // @ts-ignore
      toastr.error("Something went wrong");
      setDownloadInProgress(false);
      return;
    } else if (response.status === 204) {
      setTimeout(() => checkReportDownloadStatus(token), 2000);
    } else if (response.ok) {
      const res = await response.json();

      const link = document.createElement("a");
      // @ts-ignore
      link.href = res.events.link;
      link.download = "events_report.csv";
      link.click();
      setDownloadInProgress(false);
    }
  };

  const downloadEventsReport = async ({ events }: { events: string }) => {
    setShowDownloadOptions(false);
    setDownloadInProgress(true);
    const eventsReportURL = `/api/v1/events/start_export?events=${events}`;
    const response = await fetch(eventsReportURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Failed to start export");
    }
    const res = await response.json();
    checkReportDownloadStatus(res.token);
  };

  return (
    <div
      id="download-events"
      className="download-events-btn-container geo-lib-download"
    >
      <button
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Download all events"
        onMouseEnter={() =>
          handleShowTooltip(
            "download-events",
            "Download a CSV report to review settings for each event"
          )
        }
        onMouseLeave={() => handleHideTooltip("download-events")}
        className="download-events-btn geo-btn"
        type="button"
        disabled={downloadInProgress}
        onClick={() => {
          setShowDownloadOptions(!shouldShowDownloadOptions);
        }}
      >
        <div className="download-events-btn-content">
          <img
            src={downloadIcon}
            alt="Download events"
            className="download-events-icon"
          />
          Download events
          <img
            src={downArrowHead}
            alt="down-arrow-head"
            className="arrow-down-head"
          />
          {downloadInProgress ? (
            <div className="download-inprogress-loader-container">
              <span className="fa fa-spinner fa-spin"></span>
            </div>
          ) : null}
        </div>
      </button>
      {shouldShowDownloadOptions ? (
        <div className="geo-events-csv">
          <div className="download-events-drop-down">
            <div
              onClick={() => {
                downloadEventsReport({
                  events: "upcoming"
                });
              }}
              className="download-events-btn-title"
            >
              Upcoming events
            </div>
            <div
              onClick={() => {
                downloadEventsReport({
                  events: "all"
                });
              }}
              className="download-events-btn-title"
            >
              All events
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DownloadEvents;
